import DisputeInfo from "@/components/dispute/dispute-info";
import { createFileRoute, useRouterState } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/dispute/$disputeid")({
	component: RouteComponent
});

function RouteComponent() {
	const { disputeid } = Route.useParams();

	void disputeid;

	const { state } = useRouterState({ select: state => state.location });

	if (!state.dispute) {
		return null;
	}

	return (
		<div className="w-full lg:w-[400px] h-[calc(100vh-2rem)] sm:h-[80vh] bg-white rounded-lg overflow-y-auto">
			<div className="h-full rounded-lg p-4">
				<div className="space-y-4">
					<DisputeInfo dispute={state.dispute} />
				</div>
			</div>
		</div>
	);
}
